import { forwardRef } from 'react';
import { StyleSheet, View } from 'react-native';
import { Button as KittenButton, Spinner } from '@ui-kitten/components';

import { ButtonProps } from './types';
import { colors } from '../../theme';

export const Button = forwardRef<KittenButton, ButtonProps>(
	(
		{
			variant = 'outline',
			color = 'basic',
			size = 'medium',
			loading = false,
			style,
			children,
			...buttonProps
		},
		ref,
	) => {
		return (
			<KittenButton
				appearance={variant === 'link' ? 'ghost' : variant}
				status={color}
				style={[styles.root, style]}
				size={size}
				ref={ref}
				{...buttonProps}
			>
				{loading ? (
					<View>
						<Spinner status="control" />
					</View>
				) : (
					children
				)}
			</KittenButton>
		);
	},
);

const styles = StyleSheet.create({
	root: {},
	transparent: {
		backgroundColor: colors.transparent,
	},
});
